import React, { useEffect, useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { createPortal } from "react-dom";
import sidebarlog from "../../assets/img/frosted-farms.svg";
import "../Sidebar/Sidebar.scss";
import Dashboard from "../../assets/icons/dashboard.png";
import Company from "../../assets/icons/company.png";
import Milestone from "../../assets/icons/milestone.png";
import Activity from "../../assets/icons/activity.png";
import Room from "../../assets/icons/room.png";
import Employee from "../../assets/icons/employee.png";
import Plant from "../../assets/icons/plant.png";
import Maintenance from "../../assets/icons/maintenance.png";
import Role from "../../assets/icons/role.png";
import Location from "../../assets/icons/location.png";
import Department from "../../assets/icons/department.png";
import Sops from "../../assets/icons/sop.png";
import Schedule from "../../assets/icons/schedule.png";
import Inventory from "../../assets/icons/inventory.png";
import Tasks from "../../assets/icons/task.svg";
import Planting from "../../assets/icons/planting.svg";
import Reports from "../../assets/icons/clipboard-text.svg";
import HarvestIcon from "../../assets/icons/HarvestPlant.svg";
import ArchiveIcon from "../../assets/icons/archived.svg";
import CoaIcon from "../../assets/icons/coa-report.svg";
// import Rightarrow from "../../assets/icons/right-arrow.svg";

const menuItems = [
  {
    path: "/",
    label: "Dashboard",
    icon: Dashboard,
    roles: [1, 2, 3],
  },
  {
    path: "/schedule",
    label: "Schedule",
    icon: Schedule,
    roles: [1, 2, 3],
  },
  {
    path: "/operations",
    label: "Propagation",
    icon: Inventory,
    roles: [1, 2, 3],
    hasDropdown: true,
    dropdownItems: [
      { path: "/mother-plant", label: "Mother Plant" },
      { path: "/cluster", label: "Cluster" },
      { path: "/clone", label: "Clone" },
      { path: "/take-clone-history", label: "Take Clone History" },
      { path: "/rockwool", label: "Rockwool History" },
      // { path: "/rockwool-report", label: "Average Rooting Days Report" },
      // {
      //   path: "/rockwool-rooting-history",
      //   label: "Average Weight Loss Report For Clusters and Clones",
      // },
      // { path: "/rockwool-rooting-average", label: "Average roots from trays" },
    ],
  },
  {
    path: "/Propagation Reports",
    label: "Propagation Reports",
    icon: Reports,
    roles: [1, 2, 3],
    hasDropdown: true,
    dropdownItems: [
      { path: "/rockwool-report", label: "Average Rooting Days Report" },
      {
        path: "/rockwool-rooting-history",
        label: "Average Weight Loss Report For Clusters and Clones",
      },
      {
        path: "/rockwool-rooting-average",
        label: "Average Rooting Success per Tray",
      },
    ],
  },
  {
    path: "/plant",
    label: "Planting",
    icon: Planting,
    roles: [1, 2, 3],
    hasDropdown: true,
    dropdownItems: [
      { path: "/plant", label: "Plant" },
      { path: "/matric", label: "Metrc ID From Metrc" },
      { path: "/bucket", label: "Bucket ID" },
      { path: "/plant-mapping", label: "Plant ( Caltiver) Mapping" },
    ],
  },
  {
    path: "/fertigation",
    label: "Room Log",
    icon: Planting,
    roles: [1, 2, 3],
    hasDropdown: true,
    dropdownItems: [
      { path: "/nutrients", label: "Nutrients" },
      { path: "/full-swap", label: "Full Swap" },
      { path: "/room-log-history", label: "Room Log History" },
    ],
  },
  {
    path: "/harvest",
    label: "Harvest",
    icon: HarvestIcon,
    roles: [1, 2, 3],
  },
  {
    path: "/coa-report",
    label: "COA",
    icon: CoaIcon,
    roles: [1, 2, 3],
  },
  {
    path: "/archive-status",
    label: "Archive",
    icon: ArchiveIcon,
    roles: [1, 2, 3],
  },
  // {
  //   path: "/roomlogreport",
  //   label: "Room Log Report",
  //   icon: Room,
  //   roles: [1, 2, 3],
  // },
  {
    path: "/inventory",
    label: "Inventory",
    icon: Inventory,
    roles: [1, 2, 3],
    hasDropdown: true,
    dropdownItems: [
      { path: "/inventory", label: "Physical Inventory" },
      { path: "/reorderInventory", label: "Reorder Inventory" },
      { path: "/units", label: "Units" },
    ],
  },
  {
    path: "/company",
    label: "Companies",
    icon: Company,
    roles: [1],
  },
  {
    path: "/location",
    label: "Locations",
    icon: Location,
    roles: [1, 2],
  },
  { path: "/role", label: "Roles", icon: Role, roles: [1, 2, 3] },
  {
    path: "/department",
    label: "Departments",
    icon: Department,
    roles: [1, 2, 3],
  },

  {
    path: "/milestone",
    label: "Milestones",
    icon: Milestone,
    roles: [1, 2, 3],
  },

  {
    path: "/activities",
    label: "Activities",
    icon: Activity,
    roles: [1, 2, 3],
  },
  { path: "/task", label: "Tasks", icon: Tasks, roles: [1, 2, 3] },
  // { path: "/plant", label: "Plants", icon: Plant, roles: [1, 2, 3] },

  { path: "/room", label: "Rooms", icon: Room, roles: [1, 2, 3] },
  {
    path: "/work-task",
    label: "Maintenance",
    icon: Maintenance,
    roles: [1, 2, 3],
  },
  {
    path: "/sops",
    label: "SOPs",
    icon: Sops,
    roles: [1, 2, 3],
  },

  // { path: "/user", label: "Users", icon: Company, roles: [1, 2, 3] },
  {
    path: "/employee",
    label: "Employees",
    icon: Employee,
    roles: [1, 2, 3],
  },
  // {
  //   path: "/schedule_conflict",
  //   label: "Conflicted Schedule",
  //   icon: Schedule,
  //   roles: [1, 2, 3],
  // },
  // {
  //   path: "/reports",
  //   label: "Reports",
  //   icon: Reports,
  //   roles: [1, 2, 3],
  // },
  // Inventory dropdown with nested items

  // moved Inventory and Reorder Inventory under Inventory dropdown above
];

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [filteredMenuItems, setFilteredMenuItems] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const userRole = JSON.parse(localStorage.getItem("user"));
  const sidebarRef = useRef(null);
  const menuListRef = useRef(null);
  const toggleRefs = useRef([]);
  const portalRef = useRef(null);

  useEffect(() => {
    // Filter menu items based on user role
    const filteredItems = menuItems?.filter((item) =>
      item.roles.includes(userRole?.role_id),
    );
    setFilteredMenuItems(filteredItems);
  }, []);

  useEffect(() => {
    // Handle click outside to close dropdown
    const handleClickOutside = (event) => {
      const clickedInsideSidebar = sidebarRef.current?.contains(event.target);
      const clickedInsidePortal = portalRef.current?.contains(event.target);
      if (!clickedInsideSidebar && !clickedInsidePortal) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Helper to update dropdown position (follows the toggle button)
  const updateDropdownPosition = () => {
    if (openDropdown === null) return;
    const btn = toggleRefs.current[openDropdown];
    if (!btn) return;
    const rect = btn.getBoundingClientRect();

    // Estimate dropdown height to avoid clipping at viewport bottom
    const estimatedItemHeight = 40; // approximate per-item height
    const itemCount =
      filteredMenuItems[openDropdown]?.dropdownItems?.length || 1;
    const estimatedHeight = Math.max(40, itemCount * estimatedItemHeight + 8);

    let top = rect.top;
    const spaceBelow = window.innerHeight - rect.bottom;
    if (
      rect.top + estimatedHeight > window.innerHeight - 8 &&
      spaceBelow < estimatedHeight
    ) {
      // Position above the button when not enough space below
      top = Math.max(8, rect.bottom - estimatedHeight);
    }

    setDropdownPosition({ top, left: rect.right + 5 });
  };

  // Reposition when opening
  useEffect(() => {
    updateDropdownPosition();
  }, [openDropdown]);

  // Reposition on sidebar scroll and window resize/scroll
  useEffect(() => {
    const handleSidebarScroll = () => {
      if (openDropdown !== null) updateDropdownPosition();
    };
    const handleWindowChange = () => {
      if (openDropdown !== null) updateDropdownPosition();
    };

    const listEl = menuListRef.current;
    listEl?.addEventListener("scroll", handleSidebarScroll);
    window.addEventListener("resize", handleWindowChange);
    window.addEventListener("scroll", handleWindowChange);

    return () => {
      listEl?.removeEventListener("scroll", handleSidebarScroll);
      window.removeEventListener("resize", handleWindowChange);
      window.removeEventListener("scroll", handleWindowChange);
    };
  }, [openDropdown]);

  // Mark parent active when any child path is active and auto-open that dropdown
  const isMenuItemActive = (item) => {
    if (!item) return false;
    if (
      location.pathname === item.path ||
      location.pathname.startsWith(`${item.path}/view/`)
    ) {
      return true;
    }
    if (item.hasDropdown && Array.isArray(item.dropdownItems)) {
      return item.dropdownItems.some(
        (di) =>
          location.pathname === di.path ||
          location.pathname.startsWith(`${di.path}/`),
      );
    }
    return false;
  };

  useEffect(() => {
    if (!filteredMenuItems?.length) return;
    const idx = filteredMenuItems.findIndex(
      (mi) =>
        mi.hasDropdown &&
        mi.dropdownItems?.some(
          (di) =>
            location.pathname === di.path ||
            location.pathname.startsWith(`${di.path}/`),
        ),
    );
    setOpenDropdown(idx >= 0 ? idx : null);
  }, [location.pathname, filteredMenuItems]);

  return (
    <div className="sidebar_main" ref={sidebarRef}>
      <div
        className="offcanvas offcanvas-start"
        tab-index="-1"
        id="offcanvasExample"
        aria-labelledby="offcanvasExampleLabel"
      >
        <div className="offcanvas_header">
          <div className="header_logo">
            <Link to="/dashboard">
              <img src={sidebarlog} alt="logo" style={{ cursor: "pointer" }} />
            </Link>
          </div>
        </div>

        <div className="offcanvas-body">
          <div className="inner_sidebar">
            <div className="menu_list" id="sidebar">
              <ul
                className="menu_list_main"
                style={{ paddingBottom: "30px" }}
                ref={menuListRef}
              >
                {filteredMenuItems.map((menuItem, index) => (
                  <li className="nav-item" key={index}>
                    {menuItem.hasDropdown ? (
                      <div
                        className="btn-group dropright"
                        onClick={(e) => {
                          if (openDropdown === index) {
                            setOpenDropdown(null);
                          } else {
                            const rect =
                              e.currentTarget.getBoundingClientRect();
                            setDropdownPosition({
                              top: rect.top,
                              left: rect.right + 5,
                            });
                            setOpenDropdown(index);
                          }
                        }}
                      >
                        <Link
                          // to={menuItem.path}
                          className={`ato ${
                            isMenuItemActive(menuItem) || openDropdown === index
                              ? "active"
                              : ""
                          }`}
                        >
                          <div className="sidebar_icon">
                            <img
                              src={menuItem.icon}
                              alt={menuItem.label}
                              className=""
                            />
                          </div>
                          <span>{menuItem.label}</span>
                          <button
                            type="button"
                            className="dropdown-toggle-split"
                            aria-haspopup="true"
                            aria-expanded={openDropdown === index}
                            title="Toggle dropdown"
                            ref={(el) => (toggleRefs.current[index] = el)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="7"
                              height="14"
                              viewBox="0 0 7 14"
                              fill="none"
                            >
                              <path
                                d="M0.940002 12.2787L5.28667 7.93208C5.8 7.41875 5.8 6.57875 5.28667 6.06542L0.940002 1.71875"
                                stroke="white"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </button>
                        </Link>
                        {/* {openDropdown === index && (
                          <div
                            style={{ position: "fixed", inset: 0 }}
                            onClick={() => setOpenDropdown(null)}
                          />
                        )} */}
                      </div>
                    ) : (
                      <Link
                        to={menuItem.path}
                        className={`ato ${
                          location.pathname === menuItem.path ||
                          location.pathname.startsWith(`${menuItem.path}/view/`)
                            ? "active"
                            : ""
                        }`}
                      >
                        <div className="sidebar_icon">
                          <img
                            src={menuItem.icon}
                            alt={menuItem.label}
                            className=""
                          />
                        </div>
                        <span>{menuItem.label}</span>
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Portal Dropdown */}
      {openDropdown !== null &&
        createPortal(
          <div
            className="portal-dropdown-menu"
            style={{
              position: "fixed",
              top: dropdownPosition.top,
              left: dropdownPosition.left,
              zIndex: 9999,
              background: "#ffffff",
              border: "1px solid #e9ecef",
              borderRadius: "4px",
              boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
              minWidth: "150px",
              minHeight: "40px",
              maxHeight: "calc(100vh - 16px)",
              overflowY: "auto",
            }}
            ref={portalRef}
          >
            {filteredMenuItems[openDropdown]?.dropdownItems?.map(
              (dropdownItem, dropdownIndex) => (
                <Link
                  key={dropdownIndex}
                  to={dropdownItem.path}
                  className="portal-dropdown-item"
                  style={{
                    padding: "8px 16px",
                    color:
                      location.pathname === dropdownItem.path ||
                      location.pathname.startsWith(`${dropdownItem.path}/`)
                        ? "#00A272"
                        : "#333",
                    textDecoration: "none",
                    display: "block",
                    borderBottom:
                      dropdownIndex <
                      filteredMenuItems[openDropdown].dropdownItems.length - 1
                        ? "1px solid #eee"
                        : "none",
                  }}
                  onClick={() => setOpenDropdown(null)}
                >
                  {dropdownItem.label}
                </Link>
              ),
            )}
          </div>,
          document.body,
        )}
    </div>
  );
};

export default Sidebar;

// import React, { useEffect, useState, useRef } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { createPortal } from "react-dom";
// import sidebarlog from "../../assets/img/frosted-farms.svg";
// import "../Sidebar/Sidebar.scss";
// import Dashboard from "../../assets/icons/dashboard.png";
// import Company from "../../assets/icons/company.png";
// import Milestone from "../../assets/icons/milestone.png";
// import Activity from "../../assets/icons/activity.png";
// import Room from "../../assets/icons/room.png";
// import Employee from "../../assets/icons/employee.png";
// import Plant from "../../assets/icons/plant.png";
// import Maintenance from "../../assets/icons/maintenance.png";
// import Role from "../../assets/icons/role.png";
// import Location from "../../assets/icons/location.png";
// import Department from "../../assets/icons/department.png";
// import Sops from "../../assets/icons/sop.png";
// import Schedule from "../../assets/icons/schedule.png";
// import Inventory from "../../assets/icons/inventory.png";
// import Tasks from "../../assets/icons/task.svg";
// import Planting from "../../assets/icons/planting.svg";

// const menuItems = [
//   {
//     path: "/",
//     label: "Dashboard",
//     icon: Dashboard,
//     roles: [1, 2, 3],
//   },
//   {
//     path: "/company",
//     label: "Companies",
//     icon: Company,
//     roles: [1],
//   },
//   {
//     path: "/location",
//     label: "Locations",
//     icon: Location,
//     roles: [1, 2],
//   },
//   { path: "/role", label: "Roles", icon: Role, roles: [1, 2, 3] },
//   {
//     path: "/department",
//     label: "Departments",
//     icon: Department,
//     roles: [1, 2, 3],
//   },

//   {
//     path: "/milestone",
//     label: "Milestones",
//     icon: Milestone,
//     roles: [1, 2, 3],
//   },
//   {
//     path: "/operations",
//     label: "Propagation",
//     icon: Inventory,
//     roles: [1, 2, 3],
//     hasDropdown: true,
//     dropdownItems: [
//       { path: "/mother-plant", label: "Mother Plant" },
//       { path: "/cluster", label: "Cluster" },
//       { path: "/clone", label: "Clone" },
//       { path: "/take-clone-history", label: "Take Clone History" },
//       { path: "/rockwool", label: "Rockwool History" },
//       {
//         // path: "/plant",
//         label: "Planting",
//         icon: Planting,
//         hasDropdown: true,
//         dropdownItems: [
//           { path: "/plant", label: "Plant" },
//           { path: "/matric", label: "Metrc ID From Metrc" },
//           { path: "/bucket", label: "Bucket ID" },
//           { path: "/plant-mapping", label: "Plant (Caltiver) Mapping" },
//         ],
//       },
//     ],
//   },
//   {
//     path: "/activities",
//     label: "Activities",
//     icon: Activity,
//     roles: [1, 2, 3],
//   },
//   { path: "/task", label: "Tasks", icon: Tasks, roles: [1, 2, 3] },
//   // { path: "/plant", label: "Plants", icon: Plant, roles: [1, 2, 3] },
//   // {
//   //   path: "/plant",
//   //   label: "Planting",
//   //   icon: Planting,
//   //   roles: [1, 2, 3],
//   //   hasDropdown: true,
//   //   dropdownItems: [
//   //     { path: "/plant", label: "Plant" },
//   //     { path: "/matric", label: "Metric ID From Metric" },
//   //     { path: "/bucket", label: "Bucket ID" },
//   //     { path: "/plant-mapping", label: "Plant ( Caltiver) Mapping" },
//   //   ],
//   // },
//   { path: "/room", label: "Rooms", icon: Room, roles: [1, 2, 3] },
//   {
//     path: "/work-task",
//     label: "Maintenance",
//     icon: Maintenance,
//     roles: [1, 2, 3],
//   },
//   {
//     path: "/sops",
//     label: "SOPs",
//     icon: Sops,
//     roles: [1, 2, 3],
//   },

//   // { path: "/user", label: "Users", icon: Company, roles: [1, 2, 3] },
//   {
//     path: "/employee",
//     label: "Employees",
//     icon: Employee,
//     roles: [1, 2, 3],
//   },
//   {
//     path: "/schedule",
//     label: "Schedule",
//     icon: Schedule,
//     roles: [1, 2, 3],
//   },
//   // {
//   //   path: "/schedule_conflict",
//   //   label: "Conflicted Schedule",
//   //   icon: Schedule,
//   //   roles: [1, 2, 3],
//   // },
//   // {
//   //   path: "/reports",
//   //   label: "Reports",
//   //   icon: Reports,
//   //   roles: [1, 2, 3],
//   // },
//   // Inventory dropdown with nested items
//   {
//     path: "/inventory",
//     label: "Inventory",
//     icon: Inventory,
//     roles: [1, 2, 3],
//     hasDropdown: true,
//     dropdownItems: [
//       { path: "/inventory", label: "Physical Inventory" },
//       { path: "/reorderInventory", label: "Reorder Inventory" },
//       { path: "/units", label: "Units" },
//     ],
//   },
//   // moved Inventory and Reorder Inventory under Inventory dropdown above
// ];

// const Sidebar = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [filteredMenuItems, setFilteredMenuItems] = useState([]);
//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
//   const [openSubDropdown, setOpenSubDropdown] = useState(null);
//   const [subDropdownPosition, setSubDropdownPosition] = useState({
//     top: 0,
//     left: 0,
//   });
//   const userRole = JSON.parse(localStorage.getItem("user"));
//   const sidebarRef = useRef(null);
//   const menuListRef = useRef(null);
//   const toggleRefs = useRef([]);
//   const portalRef = useRef(null);
//   const subDropdown = useRef(null);

//   // Filter menu items by role
//   useEffect(() => {
//     const filteredItems = menuItems.filter((item) =>
//       item.roles.includes(userRole?.role_id)
//     );
//     setFilteredMenuItems(filteredItems);
//   }, []);

//   // Close dropdowns when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       const clickedInsideSidebar = sidebarRef.current?.contains(event.target);
//       const clickedInsidePortal = portalRef.current?.contains(event.target);
//       const clickedInsideSubdropdown = subDropdown.current?.contains(
//         event.target
//       );
//       if (
//         !clickedInsideSidebar &&
//         !clickedInsidePortal &&
//         !clickedInsideSubdropdown
//       ) {
//         setOpenDropdown(null);
//         setOpenSubDropdown(null);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Update dropdown position
//   const updateDropdownPosition = () => {
//     if (openDropdown === null) return;

//     const btn = toggleRefs.current[openDropdown];
//     if (!btn || !sidebarRef.current) return;
//     const rect = btn.getBoundingClientRect();
//     const sidebarRect = sidebarRef.current.getBoundingClientRect();

//     const estimatedItemHeight = 40;
//     const itemCount =
//       filteredMenuItems[openDropdown]?.dropdownItems?.length || 1;
//     const estimatedHeight = Math.max(40, itemCount * estimatedItemHeight + 8);

//     let top = rect.top - sidebarRect.top + sidebarRef.current.scrollTop;
//     const spaceBelow = window.innerHeight - rect.bottom;
//     if (
//       rect.top + estimatedHeight > window.innerHeight - 8 &&
//       spaceBelow < estimatedHeight
//     ) {
//       top = Math.max(
//         8,
//         rect.bottom -
//           estimatedHeight -
//           sidebarRect.top +
//           sidebarRef.current.scrollTop
//       );
//     }
//     const left = rect.right - sidebarRect.left + 5;
//     setDropdownPosition({ top, left });
//     setSubDropdownPosition({
//       top: top + 200,
//       left: left + 180,
//     });
//   };

//   // Reposition when opening
//   useEffect(() => {
//     updateDropdownPosition();
//   }, [openDropdown]);

//   // Handle scroll & resize
//   useEffect(() => {
//     const handleSidebarScroll = () => {
//       if (openDropdown !== null) updateDropdownPosition();
//     };
//     const handleWindowChange = () => {
//       if (openDropdown !== null) updateDropdownPosition();
//     };
//     const listEl = menuListRef.current;
//     listEl?.addEventListener("scroll", handleSidebarScroll);
//     window.addEventListener("resize", handleWindowChange);
//     window.addEventListener("scroll", handleWindowChange);
//     return () => {
//       listEl?.removeEventListener("scroll", handleSidebarScroll);
//       window.removeEventListener("resize", handleWindowChange);
//       window.removeEventListener("scroll", handleWindowChange);
//     };
//   }, [openDropdown]);

//   const isMenuItemActive = (item) => {
//     if (!item) return false;

//     const currentPath = location.pathname;

//     const checkItem = (menu) => {
//       // Match if current URL includes or starts with the menu path
//       if (
//         currentPath === menu.path ||
//         currentPath.startsWith(`${menu.path}/`) ||
//         currentPath.includes(menu.path)
//       ) {
//         return true;
//       }

//       // Recursively check nested dropdowns
//       if (menu.hasDropdown && Array.isArray(menu.dropdownItems)) {
//         return menu.dropdownItems.some(checkItem);
//       }

//       return false;
//     };

//     return checkItem(item);
//   };

//   useEffect(() => {
//     if (!filteredMenuItems?.length) return;
//     const idx = filteredMenuItems.findIndex(
//       (mi) =>
//         mi.hasDropdown &&
//         mi.dropdownItems?.some(
//           (di) =>
//             location.pathname === di.path ||
//             location.pathname.startsWith(`${di.path}/`)
//         )
//     );
//     setOpenDropdown(idx >= 0 ? idx : null);
//   }, [location.pathname, filteredMenuItems]);

//   return (
//     <div className="sidebar_main" ref={sidebarRef}>
//       <div
//         className="offcanvas offcanvas-start"
//         tabIndex="-1"
//         id="offcanvasExample"
//         aria-labelledby="offcanvasExampleLabel"
//       >
//         <div className="offcanvas_header">
//           <div className="header_logo">
//             <Link to="/dashboard">
//               <img src={sidebarlog} alt="logo" style={{ cursor: "pointer" }} />
//             </Link>
//           </div>
//         </div>

//         <div className="offcanvas-body">
//           <div className="inner_sidebar">
//             <div className="menu_list" id="sidebar">
//               <ul
//                 className="menu_list_main"
//                 style={{ paddingBottom: "30px" }}
//                 ref={menuListRef}
//               >
//                 {filteredMenuItems.map((menuItem, index) => (
//                   <li className="nav-item" key={index}>
//                     {menuItem.hasDropdown ? (
//                       <div
//                         className="btn-group dropright"
//                         onClick={(e) => {
//                           if (openDropdown === index) {
//                             setOpenDropdown(null);
//                             setOpenSubDropdown(null); // 🆕 close nested when main closes
//                           } else {
//                             const rect =
//                               e.currentTarget.getBoundingClientRect();
//                             setDropdownPosition({
//                               top: rect.top,
//                               left: rect.right + 5,
//                             });
//                             setOpenDropdown(index);
//                           }
//                         }}
//                       >
//                         <Link
//                           className={`ato ${
//                             isMenuItemActive(menuItem) ||
//                             openDropdown ||
//                             openSubDropdown
//                               ? "active"
//                               : ""
//                           }`}
//                         >
//                           <div className="sidebar_icon">
//                             <img src={menuItem.icon} alt={menuItem.label} />
//                           </div>
//                           <span>{menuItem.label}</span>
//                           <button
//                             type="button"
//                             className="dropdown-toggle-split"
//                             aria-haspopup="true"
//                             aria-expanded={openDropdown === index}
//                             ref={(el) => (toggleRefs.current[index] = el)}
//                           >
//                             <svg
//                               xmlns="http://www.w3.org/2000/svg"
//                               width="7"
//                               height="14"
//                               viewBox="0 0 7 14"
//                               fill="none"
//                             >
//                               <path
//                                 d="M0.94 12.2787L5.28667 7.93208C5.8 7.41875 5.8 6.57875 5.28667 6.06542L0.94 1.71875"
//                                 stroke="white"
//                                 strokeWidth="1.5"
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                               />
//                             </svg>
//                           </button>
//                         </Link>
//                       </div>
//                     ) : (
//                       <Link
//                         to={menuItem.path}
//                         className={`ato ${
//                           location.pathname === menuItem.path ||
//                           location.pathname.startsWith(`${menuItem.path}/view/`)
//                             ? "active"
//                             : ""
//                         }`}
//                       >
//                         <div className="sidebar_icon">
//                           <img src={menuItem.icon} alt={menuItem.label} />
//                         </div>
//                         <span>{menuItem.label}</span>
//                       </Link>
//                     )}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Main Dropdown */}
//       {openDropdown !== null &&
//         createPortal(
//           <div
//             className="portal-dropdown-menu"
//             style={{
//               position: "fixed",
//               top: dropdownPosition.top,
//               left: dropdownPosition.left,
//               background: "#fff",
//               border: "1px solid #e9ecef",
//               borderRadius: "4px",
//               boxShadow: "0 0.5rem 1rem rgba(0,0,0,0.15)",
//               minWidth: "160px",
//               maxHeight: "calc(100vh - 16px)",
//               overflowY: "auto",
//               zIndex: 9999,
//             }}
//             ref={portalRef}
//           >
//             {filteredMenuItems[openDropdown]?.dropdownItems?.map(
//               (dropdownItem, i) => {
//                 const hasSub = dropdownItem.hasDropdown;
//                 return (
//                   <div
//                     key={i}
//                     style={{
//                       position: "relative",
//                       borderBottom: "1px solid #eee",
//                     }}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       if (hasSub) {
//                         const rect = e.currentTarget.getBoundingClientRect();
//                         setSubDropdownPosition({
//                           top: rect.top,
//                           left: rect.right + 5,
//                         });
//                         setOpenSubDropdown(openSubDropdown === i ? null : i);
//                       } else {
//                         setOpenDropdown(null);
//                         navigate(dropdownItem.path);
//                       }
//                     }}
//                   >
//                     <Link
//                       to={dropdownItem.path || "#"}
//                       style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         padding: "8px 16px",
//                         color:
//                           location.pathname === dropdownItem.path
//                             ? "#00A272"
//                             : dropdownItem?.dropdownItems?.some((item) =>
//                                 location.pathname.includes(item.path)
//                               )
//                             ? "#00A272"
//                             : "#333",
//                         textDecoration: "none",
//                       }}
//                       onClick={() => !hasSub && setOpenDropdown(null)}
//                     >
//                       {dropdownItem.label}
//                       {hasSub && (
//                         <svg
//                           xmlns="http://www.w3.org/2000/svg"
//                           width="7"
//                           height="14"
//                           viewBox="0 0 7 14"
//                           fill="none"
//                         >
//                           <path
//                             d="M0.94 12.2787L5.28667 7.93208C5.8 7.41875 5.8 6.57875 5.28667 6.06542L0.94 1.71875"
//                             stroke="#333"
//                             strokeWidth="1.5"
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                           />
//                         </svg>
//                       )}
//                     </Link>

//                     {hasSub &&
//                       openSubDropdown === i &&
//                       createPortal(
//                         <div
//                           className="portal-sub-dropdown"
//                           style={{
//                             position: "fixed",
//                             top: subDropdownPosition.top,
//                             left: subDropdownPosition.left,
//                             background: "#fff",
//                             border: "1px solid #e9ecef",
//                             borderRadius: "4px",
//                             boxShadow: "0 0.5rem 1rem rgba(0,0,0,0.15)",
//                             minWidth: "160px",
//                             maxHeight: "calc(100vh - 16px)",
//                             overflowY: "auto",
//                             zIndex: 11000,
//                           }}
//                           ref={subDropdown}
//                         >
//                           {dropdownItem.dropdownItems?.map((subItem, j) => (
//                             <Link
//                               key={j}
//                               to={subItem.path}
//                               style={{
//                                 display: "block",
//                                 padding: "8px 16px",
//                                 color:
//                                   location.pathname === subItem.path
//                                     ? "#00A272"
//                                     : "#333",
//                                 textDecoration: "none",
//                                 borderBottom:
//                                   j < dropdownItem.dropdownItems.length - 1
//                                     ? "1px solid #eee"
//                                     : "none",
//                               }}
//                               onClick={() => {
//                                 setOpenDropdown(null);
//                                 setOpenSubDropdown(null);
//                               }}
//                             >
//                               {subItem.label}
//                             </Link>
//                           ))}
//                         </div>,
//                         document.body
//                       )}
//                   </div>
//                 );
//               }
//             )}
//           </div>,
//           document.body
//         )}
//     </div>
//   );
// };

// export default Sidebar;
